import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { LoadingService } from './app-layout/loading-service';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Skip auth-related errors - they are handled by AuthInterceptor
      if (
        error.status === 401 ||
        req.url.includes('/oauth/token') ||
        req.url.includes('/refresh')
      ) {
        return throwError(() => error);
      }

      // Power BI embed errors are handled in DashboardComponent
      if (req.url.includes('/powerbi/embed-config')) {
        return throwError(() => error);
      }

      // Automatically handle common errors and reset loading state
      if (error.status === 404) {
        loadingService.handleError(error, 'De gevraagde gegevens zijn niet gevonden');
      } else if (error.status === 403) {
        loadingService.handleError(error, 'U heeft geen toegang tot deze gegevens');
      } else if (error.status === 500) {
        loadingService.handleError(error, 'Er is een serverfout opgetreden');
      } else if (error.status === 0) {
        loadingService.handleError(error, 'Kan geen verbinding maken met de server');
      } else if (error.status >= 400) {
        loadingService.handleError(error, 'Er is een fout opgetreden');
      }

      return throwError(() => error);
    })
  );
};
